import React from "react";
import { Box, Button, Typography } from "@mui/material";

const DevIdeSqlList = ({ activeChange, sqlFiles, onOpenSqlEditor }) => {
  if (!activeChange || !activeChange.id) return null;
  if (!sqlFiles || sqlFiles.length === 0) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="subtitle2">SQL files for change</Typography>
      <Box
        sx={{
          maxHeight: 140,
          overflowY: "auto",
          mt: 0.5,
          border: "1px solid rgba(0,0,0,0.12)",
          borderRadius: 1,
          p: 0.5,
        }}
      >
        {sqlFiles.map((sf) => (
          <Button
            key={sf.id}
            variant="text"
            size="small"
            onClick={() => onOpenSqlEditor(sf)}
            sx={{
              justifyContent: "flex-start",
              textTransform: "none",
              width: "100%",
              fontFamily: "monospace",
            }}
          >
            {sf.path || sf.filename || `SQL #${sf.id}`}
            {sf.executed && (
              <Typography
                component="span"
                variant="caption"
                color="success.main"
                sx={{ ml: 1 }}
              >
                (executed)
              </Typography>
            )}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default DevIdeSqlList;
